<template>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <InputTypes
            v-model:value="no"
            type="text"
            :maxlength="10"
            label="身分證號碼"
            :errorMsg="errors.account"
            @validateValue="validateId"
        />
        <InputTypes
            label="出生年月日"
            :errorMsg="errors.birthday"
        >
            <template #input>
                <button
                    class="w-full md:max-w-[18.75rem] md::w-[18.75rem] input-base input-calendar flex-shrink-0"
                    @click="visiblePopup=true"
                    v-text="birthday"
                />
            </template>
        </InputTypes>

        <DatePicker
            v-model:visiblePopup="visiblePopup"
            v-model:userDate="birthday"
            :isYearROC="true"
            :maxDate="today()"
            minDate="1/02/02"
        />

        <InputTypes
            label="驗證碼"
            :errorMsg="errors.verifyCode"
        >
            <template #input>
                <InputIdentify
                    v-model:value="verifyCode"
                    v-model:reFresh="reFresh"
                    @validateValue="getIsPassverifyCode"
                />
            </template>
        </InputTypes>

        <div class="flex justify-center pt-2">
            <button
                class="btn w-full rounded-full gradient-primary border-0 max-w-[8.75rem]"
                @click.prevent="postApi"
            >
                確定
            </button>
        </div>
        <br>
        <div class="text-[1.0rem] text-primary text-center px-4">
            <a
                target="_blank"
                href="https://www.fubon.com/life/statement/privacy/web-privacy/"
            >
                隱私權聲明
            </a>
        </div>
    </div>
</template>

<script>
import { reactive, ref, toRefs, watch } from 'vue';
import InputTypes from '@/components/inputs/InputTypes.vue';
import DatePicker from '@/components/dialogs/DatePicker.vue';
import InputIdentify from '@/components/inputs/InputIdentify.vue';
import { localAndForeignID } from '@/utils/rules/customRules';

export default {
    components: {
        DatePicker,
        InputTypes,
        InputIdentify,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
        bd: {
            type: String,
            default: '',
        },
    },
    emits: ['update:bd', 'update:id', 'postApi'],
    setup(props, { emit }) {
        const users = reactive({
            no: props.id,
            birthday: props.bd,
            verifyCode: '',
            errors: {
                account: '',
                birthday: '',
                verifyCode: '',
            },
            reFresh: false,
        });
        const visiblePopup = ref(false);
        const isPassVerified = ref(false);
        const getIsPassverifyCode = (isPass) => {
            isPassVerified.value = isPass;
            users.errors.verifyCode = '';
        };

        const today = () => {
            const y = new Date().getFullYear() - 1911;
            const m = new Date().getMonth() + 1;
            const d = new Date().getDate();
            return `${y}/${m}/${d}`;
        };

        const validateId = (id) => {
            const { message, val } = localAndForeignID({ value: id, errorMessage: '', isMustHave: true });
            users.no = val;
            users.errors.account = message;
            emit('update:id', val);
        };

        const validateVerifyCode = (value) => {
            if (value === '') {
                users.errors.verifyCode = '請輸入驗證碼';
            } else if (!isPassVerified.value) {
                users.errors.verifyCode = '請輸入正確的驗證碼';
            }
        };

        const postApi = () => {
            let canPost = false;
            validateId(users.no);
            validateVerifyCode(users.verifyCode);
            if (!users.birthday) {
                users.errors.birthday = '請選擇出生年月日';
            }
            if (!users.errors.account && !users.errors.birthday && !users.errors.verifyCode && users.no && users.birthday) {
                canPost = true;
            }
            emit('postApi', canPost);
        };

        watch(() => users.birthday, (nV) => {
            if (nV) {
                users.errors.birthday = '';
            }
            emit('update:bd', nV);
        });
        return {
            ...toRefs(users),
            validateId,
            getIsPassverifyCode,
            visiblePopup,
            today,
            postApi
        };
    },
};
</script>
